export const GENERAL_ADMIN_SCOPE_VALUE = "__general_administration__";
